import Vue from 'vue';
import vueCountryRegionSelect from 'vue-country-region-select';

Vue.use(vueCountryRegionSelect);
